// src/scripts/fluco-lib/events.js
var EVENTS = {
  SHOPIFY_BLOCK_SELECT: "shopify:block:select",
  SHOPIFY_BLOCK_DESELECT: "shopify:block:deselect",
  SHOPIFY_SECTION_DESELECT: "shopify:section:deselect",
  SHOPIFY_SECTION_SELECT: "shopify:section:select",
  SHOPIFY_SECTION_LOAD: "shopify:section:load",
  SHOPIFY_SECTION_UNLOAD: "shopify:section:unload",
  COUNTDOWN_TIMER_COMPLETED_EVENT: "fluco_section:countdown_timer_completed"
};
var events_default = EVENTS;

// src/scripts/sections/grid-bento-1.js
var { SHOPIFY_BLOCK_SELECT, SHOPIFY_BLOCK_DESELECT } = events_default;
var GridBento1 = class extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      timerGroup: "[js-timer-group]"
    };
  }
  connectedCallback() {
    this.eventController = new AbortController();
    this.eventOptions = { signal: this.eventController.signal };
    this.timerGroup = this.querySelector(this.selectors.timerGroup);
    this.timerGroupReplaceContentWhenCompleted = this.timerGroup?.getAttribute("data-replace-content-when-completed") === "true";
    if (window.Shopify.designMode) {
      this.setAttribute("data-theme-editor", "true");
      this.parentElement.addEventListener(
        SHOPIFY_BLOCK_SELECT,
        (e) => {
          this.handleBlockSelected(e);
        },
        this.eventOptions
      );
      this.parentElement.addEventListener(
        SHOPIFY_BLOCK_DESELECT,
        (e) => this.handleBlockDeselected(e),
        this.eventOptions
      );
    }
  }
  disconnectedCallback() {
    this.eventController.abort();
  }
  /**
   * If selected block is "Countdown completed", show the completed content in the editor preview.
   * @param {Object} e - The block event for the selected block.
   */
  handleBlockSelected(e) {
    const blockType = this.getBlockType(e);
    if (blockType === "countdown-completed") {
      this.timerGroup.setAttribute(
        "data-editor-content-override",
        this.timerGroupReplaceContentWhenCompleted
      );
    }
  }
  /**
   * If deselected block is "Countdown completed", hide the completed content in the editor preview.
   * @param {Object} e - The block event for the selected block.
   */
  handleBlockDeselected(e) {
    const blockType = this.getBlockType(e);
    if (blockType === "countdown-completed") {
      this.timerGroup.setAttribute("data-editor-content-override", "false");
    }
  }
  /**
   * Returns the block type associated with the block event.
   * @param {Object} e - The block event for the selected block.
   * @returns {String} The block type.
   */
  getBlockType(e) {
    return e.target.getAttribute("data-block-type");
  }
};
if (!customElements.get("fluco-local-v2-grid-bento-1")) {
  customElements.define("fluco-local-v2-grid-bento-1", GridBento1);
}
